import { defineMessages } from 'react-intl';

const messages = defineMessages({
  packingSlipOnLabelWarning: {
    description: 'unable to adjust packing slip options because it is included on the label warning',
    defaultMessage: 'Packing slips printed with labels inherit the format set in the label document options.',
    id: '92kAq2',
  },
  packingSlipOptionsDescription: {
    description: 'Packing slip print setup modal description',
    defaultMessage: 'Choose how your Packing Slips appear.',
    id: '3DeLVy',
  },
  packingSlipFormatLabel: {
    description: 'Packing slip format label',
    defaultMessage: 'Packing Slip Format',
    id: 'h/dFJs',
  },
  packingSlipZeroQuantity: {
    description: 'Packing slip option to show line items with 0 quantity',
    defaultMessage: 'Show 0 quantity items',
    id: 'i9uslv',
  },
  packingSlipZeroQuantityDescription: {
    description: 'Packing slip zero quantity description',
    defaultMessage: 'Allows you to show or hide line items when the quantity for the item is 0',
    id: '54aW3g',
  },
  packingSlipHideZeroQuantityLabel: {
    description: 'Label for option to hide line items with 0 quantity',
    defaultMessage: 'Zero Quantity Items',
    id: 'ymOwN/',
  },
  packingSlip4x6: {
    description: 'Packing slip 4 X 6 format',
    defaultMessage: '4" x 6" (thermal printer)',
    id: 'WmntyC',
  },
  packingSlipHalfLetter: {
    description: 'Packing slip half letter format',
    defaultMessage: '8.5" x 11" (2 per page)',
    id: 'RUnMwR',
  },
  packingSlipLetter: {
    description: 'Packing slip letter format',
    defaultMessage: '8.5"x11" (full page)',
    id: '52LYE/',
  },
  packingSlipAFour: {
    description: 'Packing slip A4 format',
    defaultMessage: 'A4',
    id: 'zp6NmK',
  },
  packingSlipASix: {
    description: 'Packing slip A6 format',
    defaultMessage: 'A6',
    id: 'kZNLw/',
  },
  orderItemsByLabel: {
    description: 'Packing slip order items by label',
    defaultMessage: 'Sort items by:',
    id: '10X1l0',
  },
  orderItemsByDescription: {
    description: 'Packing slip order items by description',
    defaultMessage: "Determines the sequence an order's items are listed",
    id: 'isuSFy',
  },
  sku: {
    description: 'Packing slip order items by sku ascending',
    defaultMessage: 'SKU',
    id: '+jR5MF',
  },
  name: {
    description: 'Packing slip order items by name ascending',
    defaultMessage: 'Name',
    id: 'AW8Fq4',
  },
  itemLowToHigh: {
    description: 'Packing slip order items by quantity ascending',
    defaultMessage: 'Item Quantity (low to high)',
    id: 'g8sCGO',
  },
  itemHighToLow: {
    description: 'Packing slip order items by quantity descending',
    defaultMessage: 'Item Quantity (high to low)',
    id: 'xgFyYQ',
  },
  warehouseLocation: {
    description: 'Packing slip order items by warehouse location',
    defaultMessage: 'Warehouse Location',
    id: 'W3Usp0',
  },
  none: {
    description: 'Packing slip order items by none',
    defaultMessage: 'None',
    id: 'ldeWvk',
  },
  storeLogoLabel: {
    description: 'Packing slip include store logo label',
    defaultMessage: 'Store Logo',
    id: 'O2bsyx',
  },
  storeLogoOption: {
    description: 'Packing slip include store logo option',
    defaultMessage: 'Show store logo',
    id: 'Ep0ZpN',
  },
  storeLogoTitle: {
    description: 'Packing slip store logo title',
    defaultMessage: 'Show store logo:',
    id: 'ZkFpe2',
  },
  storeLogoDescription: {
    description: 'Packing slip store logo description',
    defaultMessage: 'This will print the logo uploaded in your Store Settings',
    id: '4uzh9L',
  },
  itemPriceLabel: {
    description: 'Packing slip include item price label',
    defaultMessage: 'Item Prices',
    id: '5J6SMi',
  },
  itemPriceOption: {
    description: 'Packing slip include item price option',
    defaultMessage: 'Show item prices',
    id: 'BQJ0Ar',
  },
  itemPriceTitle: {
    description: 'Packing slip item price title',
    defaultMessage: 'Show item prices:',
    id: 'NcdmMM',
  },
  itemPriceDescription: {
    description: 'Packing slip item price description',
    defaultMessage: "Allows you to show or hide an item's price",
    id: 'TrNsz6',
  },
  itemSkuLabel: {
    description: 'Packing slip include item SKU label',
    defaultMessage: 'Item SKUs',
    id: 'v7pKus',
  },
  itemSkuOption: {
    description: 'Packing slip include item SKU option',
    defaultMessage: 'Show item SKUs',
    id: '063KBy',
  },
  itemSkuTitle: {
    description: 'Packing slip item SKU title',
    defaultMessage: 'Show item SKUs:',
    id: 'UjhbV0',
  },
  itemSkuDescription: {
    description: 'Packing slip item SKU description',
    defaultMessage: "Allows you to show or hide an item's SKU",
    id: 'oIwLFj',
  },
  scanToViewLabel: {
    description: 'Packing slip include scan barcode label',
    defaultMessage: '"Scan to View" Barcode',
    id: 'fR5vIC',
  },
  scanToViewOption: {
    description: 'Packing slip include scan barcode option',
    defaultMessage: 'Show "Scan to View" barcode',
    id: 'vwQT8m',
  },
  scanToViewTitle: {
    description: 'Packing slip scan to view title',
    defaultMessage: 'Show "Scan to View" barcode:',
    id: 'RZiiAi',
  },
  scanToViewDescription: {
    description: 'Packing slip scan to view description',
    defaultMessage: 'This barcode opens the Order Details of that order while in any part of ShipStation',
    id: '2mDWek',
  },
  itemLocationLabel: {
    description: 'Packing slip include inventory location label',
    defaultMessage: 'Item Locations',
    id: 'B1bU29',
  },
  itemLocationOption: {
    description: 'Packing slip include inventory location option',
    defaultMessage: 'Show item locations',
    id: '4kwpPK',
  },
  itemLocationTitle: {
    description: 'Packing slip item location title',
    defaultMessage: 'Show item locations:',
    id: 'E6Fi6J',
  },
  itemLocationDescription: {
    description: 'Packing slip item location description',
    defaultMessage: "Allows you to include the product's Inventory Warehouse Location",
    id: 'ZZzkhh',
  },
  showDiscountsLabel: {
    description: 'Packing slip include discounts as line items label',
    defaultMessage: 'Discounts',
    id: 'qn/Z5I',
  },
  showDiscountsOption: {
    description: 'Packing slip include discounts as line items option',
    defaultMessage: 'Show discounts as line items',
    id: 'Usr9By',
  },
  showDiscountsTitle: {
    description: 'Packing slip show discounts title',
    defaultMessage: 'Show discounts as line items:',
    id: 'pAXkOE',
  },
  showDiscountsDescription: {
    description: 'Packing slip show discounts description',
    defaultMessage: 'Allows you to show or hide coupons or discount codes as line items',
    id: 'T26rIc',
  },
  hideZeroQuantityTitle: {
    description: 'Packing slip hide zero quantity title',
    defaultMessage: 'Hide 0 quantity items:',
    id: 'fCVyRL',
  },
  hideZeroQuantityDescription: {
    description: 'Packing slip hide zero quantity description',
    defaultMessage: 'Allows you to show or hide line items when the quantity for the item is 0',
    id: 'G9dRlW',
  },
  returnQrCodeLabel: {
    description: 'Packing slip include return QR code label',
    defaultMessage: 'Return QR Code',
    id: 'M5B+TA',
  },
  returnQrCodeOption: {
    description: 'Packing slip include return QR code option',
    defaultMessage: 'Show QR code to allow customers to start a return',
    id: 'MzfiMj',
  },
  perPackageSectionsLabel: {
    description: 'Packing slip per-package sections label',
    defaultMessage: 'Package Sections',
    id: 's+lEvS',
  },
  perPackageSectionsOption: {
    description: 'Packing slip option to list items in a separate section for each package of a multi-package order',
    defaultMessage: 'Show items in a separate section for each package',
    id: 'UAvSXL',
  },
  returnQrCodeDisabledTooltip: {
    description: 'Tooltip shown when return QR code toggle is disabled because returns portal is not enabled',
    defaultMessage: 'Returns Portal has not been enabled. Go to your Store Settings → Returns to set this up.',
    id: 'mAw7Cb',
  },
  packingSlipCustomizationFeatureName: {
    description: 'Packing slip customization feature name',
    defaultMessage: 'Packing Slip Feature',
    id: 'R6uZjh',
  },
});

export default messages;
